/**
 * Provider button helpers - icon per provider name.
 * When adding a new provider (Microsoft/LinkedIn/Apple/GitHub),
 * add its SVG here and the Login/Register buttons will render automatically.
 */
import React from "react";

const GOOGLE = (
  <svg className="h-4 w-4" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.9 0 7.4 1.4 10.2 3.7l7.6-7.6C37 1.9 30.9 0 24 0 14.6 0 6.5 5.3 2.5 13l8.9 6.9C13.4 13.6 18.2 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.6-4.9 7.3l7.5 5.8c4.4-4.1 7.2-10.1 7.2-17.6z"/>
    <path fill="#FBBC05" d="M11.4 28.7c-.5-1.5-.8-3.1-.8-4.7s.3-3.2.8-4.7L2.5 12.5C.9 15.9 0 19.8 0 24s.9 8.1 2.5 11.5l8.9-6.8z"/>
    <path fill="#34A853" d="M24 48c6.5 0 12-2.1 16-5.8l-7.5-5.8c-2.1 1.4-4.8 2.3-8.5 2.3-5.8 0-10.7-4.1-12.6-9.6l-8.9 6.9C6.5 42.7 14.6 48 24 48z"/>
  </svg>
);

const MICROSOFT = (
  <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#F25022" d="M1 1h10v10H1z" />
    <path fill="#7FBA00" d="M13 1h10v10H13z" />
    <path fill="#00A4EF" d="M1 13h10v10H1z" />
    <path fill="#FFB900" d="M13 13h10v10H13z" />
  </svg>
);

const APPLE = (
  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.365 1.43c0 1.14-.42 2.22-1.12 3.01-.75.85-1.99 1.51-3.02 1.43-.13-1.12.42-2.29 1.12-3.03.75-.85 2.02-1.5 3.02-1.41zM20.5 17.4c-.55 1.27-.82 1.84-1.53 2.96-.99 1.57-2.38 3.53-4.11 3.55-1.54.02-1.94-1-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.72-.02-3.04-1.79-4.03-3.36C.29 16.03-.66 8.6 3.99 5.06c1.35-1.03 3.03-1.63 4.61-1.63 1.55 0 2.53.85 3.81.85 1.24 0 2-.86 3.78-.86 1.5 0 3.09.82 4.22 2.24-3.7 2.03-3.1 7.32.09 8.74z"/>
  </svg>
);

const LINKEDIN = (
  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="#0A66C2" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.446-2.136 2.94v5.666H9.351V9h3.414v1.561h.049c.476-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const GITHUB = (
  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.56v-2c-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.28-1.68-1.28-1.68-1.04-.72.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.72-1.55-2.55-.29-5.24-1.28-5.24-5.71 0-1.26.45-2.29 1.18-3.1-.12-.29-.51-1.46.11-3.05 0 0 .97-.31 3.18 1.18a11.02 11.02 0 015.79 0c2.21-1.49 3.18-1.18 3.18-1.18.62 1.59.23 2.76.11 3.05.73.81 1.18 1.84 1.18 3.1 0 4.44-2.69 5.42-5.25 5.7.41.36.78 1.06.78 2.14v3.17c0 .31.21.68.8.56A11.52 11.52 0 0023.5 12C23.5 5.65 18.35.5 12 .5z"/>
  </svg>
);

const ICONS = {
  google: GOOGLE,
  microsoft: MICROSOFT,
  apple: APPLE,
  linkedin: LINKEDIN,
  github: GITHUB,
};

export function ProviderIcon({ icon }) {
  return ICONS[icon] || GOOGLE;
}
